export type Details = {
  badge?: string;
  title: string;
  accentWord?: string;
  subtitle?: string;
};

export const ServicesPageDetails: Details = {
  badge: 'Administração Local',
  title: 'Serviços ao Cidadão.',
  accentWord: 'Cidadão.',
  subtitle:
    'Aceda aos requerimentos, licenças e serviços administrativos \
    disponibilizados pela Junta de Freguesia.',
};
